import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesArticulos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Vinos", items: [
      { label: "Vinos", icon: "fas fa-wine-bottle", color: "#3b82f6", href: "/ListadoArticulos", desc: "Alta y listado de vinos", enabled: !!user.menu_articulos },
    ]},
    { section: "Catálogos", items: [
      { label: "Tipos de vino", icon: "fas fa-wine-glass-alt", color: "#6366f1", href: "/Lineas", desc: "Tinto, blanco, rosado, espumoso", enabled: !!user.menu_articulos },
      { label: "Regiones", icon: "fas fa-globe-americas", color: "#10b981", href: "/Familias", desc: "Regiones y denominaciones", enabled: !!user.menu_articulos },
      { label: "Varietales", icon: "fas fa-seedling", color: "#8b5cf6", href: "/Colecciones", desc: "Uvas y mezclas", enabled: !!user.menu_articulos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Vinos"
      descripcion="Catálogo de vinos y sus atributos"
      icono="fas fa-wine-bottle"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesArticulos;
